module.exports = __webpack_public_path__ + "img/9.4ced2fb6.jpg";